module.exports = __webpack_public_path__ + "static/media/logo.2667f13e.png";